export const ButtonWrapper = `
  border: 1px solid #c9cbcd;
  background-color: white;
  font-size: 14px;
  height: 32px;
  padding: 4px;
  padding-right: 0px;
  border-radius: 6px;
  position: relative;
  display: inline-flex;
  align-items: center;
  &:hover {
    border-color: #2969ff;
  }
`;

export const ButtonLabel = `
  border-right: 1px solid #c9cbcd;
  padding: 4px;
  color: #868686;
`;
